import React from "react";
import { TransformedProduct } from "../../../../templates/ecommerce/product/types/productApiTypes";
import ProductPriceDisplay from "../../../../templates/ecommerce/product/components/common/ProductPriceDisplay";
import { decodeHtmlEntities } from "../../../../common/helpers/decodeHtmlEntities";

interface MinimalProductCardProps {
  product: TransformedProduct;
}

const MinimalProductCard: React.FC<MinimalProductCardProps> = ({ product }) => {
  const image = product.mainImage;
  const decodedName = decodeHtmlEntities(product.name);

  return (
    <a href={product.permalink} className="fast-minimal-card">
      <div className="fast-minimal-card__image-wrapper">
        {image ? (
          <img
            src={image.thumbnail}
            alt={image.alt || decodedName}
            className="fast-minimal-card__image"
            loading="lazy"
          />
        ) : (
          <div className="placeholder-image"></div>
        )}
      </div>
      <div className="fast-minimal-card__details">
        <h4 className="fast-minimal-card__title">{decodedName}</h4>
        {/* Re-use the existing core price display component for standard formatting */}
        <ProductPriceDisplay
          product={product}
          className="fast-minimal-card__price"
        />
      </div>
    </a>
  );
};

export default MinimalProductCard;
